import React from "react";
import { projecManagerResponsibilitiesData } from "./CareersConfig";

function FirstCareers() {
  return (
    <>
      <div className="bg-midBlue text-white font-sans py-[72px]">
        <div className="w-11/12 sm:w-9/12 mx-auto py-[64px]">
          <h1 className="text-[42px] sm:text-[48px] lg:text-60 bg-contact-img custom-bg-pos bg-no-repeat leading-[40px] lg:leading-[60px] inline-block font-medium w-auto lg:w-max font-riot custom-bg-h1 mb-4">
            Jobs at Tomedes
          </h1>
        </div>
        <div className="w-11/12 sm:w-10/12 xl:w-8/12 max-w-6xl mx-auto text-24 leading-7">
          <div className="sm:w-11/12 mx-auto">
            <h2 className="text-40 leading-[50px] mb-10 text-center font-medium">
              Project Manager
            </h2>
            <p className="mb-4">About This Job |</p>
            <p className="font-light mb-9">
              We are a fast growing international company in the translation
              industry and we are looking for a talented and driven Project
              Manager to join our team.
            </p>
            <p className="mb-4">Position Summary |</p>
            <p className="font-light mb-9">
              Full responsibility for managing and coordinating the completion
              of all language projects. Providing excellent and professional
              service to both clients and vendors by e-mail, phone, chat and
              other on-line platforms.
            </p>
            <p className="mb-10 pt-[44px]">Roles Requirements |</p>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-7 text-[21px] font-light">
              <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
                <img
                  src="https://skins.tomedes.com/frontend/images/careers_icons/5-6days.svg"
                  alt=""
                  className="w-16"
                />
                <p>Full time position, 5-6 days per week.</p>
              </div>
              <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
                <img
                  src="https://skins.tomedes.com/frontend/images/careers_icons/shifts.svg"
                  alt=""
                  className="w-16"
                />
                <p>Shifts are 24/7 on a changing rota basis.</p>
              </div>
              <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
                <img
                  src="https://skins.tomedes.com/frontend/images/careers_icons/communication.svg"
                  alt=""
                  className="w-16"
                />
                <p>
                  Excellent English communication, comprehension and writing
                  skills
                </p>
              </div>
              <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
                <img
                  src="https://skins.tomedes.com/frontend/images/careers_icons/customer_support.svg"
                  alt=""
                  className="w-16"
                />
                <p>
                  Past experience with providing customer service to clients
                </p>
              </div>
              <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
                <img
                  src="https://skins.tomedes.com/frontend/images/careers_icons/correspondence.svg"
                  alt=""
                  className="w-16"
                />
                <p>
                  Experience with verbal and written correspondence with clients
                </p>
              </div>
              <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
                <img
                  src="https://skins.tomedes.com/frontend/images/careers_icons/work_alone.svg"
                  alt=""
                  className="w-16"
                />
                <p>Able to work alone</p>
              </div>
              <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
                <img
                  src="https://skins.tomedes.com/frontend/images/careers_icons/clean.svg"
                  alt=""
                  className="w-16"
                />
                <p>Very organized and able to priorities tasks</p>
              </div>
              <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
                <img
                  src="https://skins.tomedes.com/frontend/images/careers_icons/multitask.svg"
                  alt=""
                  className="w-16"
                />
                <p>Able to multi-function - many tasks at the same time</p>
              </div>
            </div>
          </div>
        </div>
        <div className="w-11/12 sm:w-10/12 xl:w-9/12 max-w-6xl mx-auto text-24 leading-7">
          <p className="text-24 left-7 mb-10 pt-[52px]">
            Position Responsibilities |
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7 text-[21px] font-light">
            {projecManagerResponsibilitiesData &&
              projecManagerResponsibilitiesData.map(({ text }, i) => {
                return (
                  <div
                    className="bg-black rounded-lg shadow-lg px-7 py-4 flex items-center justify-center"
                    key={i}
                  >
                    <p className="text-center">{text}</p>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
}

export default FirstCareers;
